import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { connect } from "react-redux";

import { Panel, PanelHeader } from '../../header/panel/panel';
import TableView from '../Table/Table';

import { fetchAllPOSClients, fetchPOSClient, filteredData, setEdited, setModified, setPOSClientID } from '../../../redux/actions/POSClientActions';
import { tableHeadings } from '../../../utils/constants';


const POSClientList = (props) => {

    const navigate = useNavigate()

    const [searchValue, setSearchValue] = useState('');


    useEffect(() => {
        props.fetchAllPOSClients()
        props.setModified(false)
        props.filteredData()

        return () => {
            props.setEdited(false)
        }
    }, [])

    const handleClick = (value) => {
        props.setPOSClientID(value.data.posClientID)
        console.log(value.data.posClientID)
        navigate('/posclient/view')
    }


    const handleSearch = (event) => {
        setSearchValue(event.target.value)
        let filteredClients = event.target.value && event.target.value.length ? props.POSCLIENTREDUCER.posClientsData.filter(client => {
            if (client.isoName.toLowerCase().includes(event.target.value.toLowerCase())) {
                return client
            }
            return false
        }) : []

        props.filteredData(filteredClients)

    }



    return (

        <Panel>

            <PanelHeader>

                <div className="row mb-0">

                    <div className="col-xl-9">
                        <h4>POS Clients</h4>
                    </div>
                    <div className="col-xl-2">
                        <input type="text" className="form-control" placeholder="Search..." onChange={handleSearch} />

                    </div>
                    <div className="col-xl-1">
                        {/* {props.LOGINREDUCER.USER.role == 1 ? <button className="btn btn-sm btn-secondary d-block w-40 btn-lg h-35px fs-09px" onClick={handleAddISO}>Add ISO</button>
                            : null} */}
                    </div>

                </div>


            </PanelHeader>

            <TableView height={596} count = {13} headings={tableHeadings.posClient} data={(props.POSCLIENTREDUCER.filteredData && props.POSCLIENTREDUCER.filteredData.length) || searchValue ? props.POSCLIENTREDUCER.filteredData : props.POSCLIENTREDUCER.posClientsData} handleClick={handleClick} />

        </Panel>


    )

}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchAllPOSClients,
    fetchPOSClient,
    filteredData,
    setEdited,
    setModified,
    setPOSClientID
}


export default connect(mapStateToProps, mapDispatchToProps)(POSClientList);